<style lang="postcss">
  :global(.navBarLink) {
    @apply py-2 px-4 text-white font-semibold rounded-lg transform transition duration-500 focus:outline-none;
  }

  #flexbox {
      display: flex;
      flex-flow: row;
  }

  .flexed {
    flex: 0.25 0 auto;
    transition: 500ms ease-in;
  }

  @font-face {
  font-family: myFirstFont;
  src: url('../../harukaze.otf');
}

  .logo {
    font-family: myFirstFont;
    @apply font-light text-7xl;
  }

  .logo {
    -webkit-transition: all 1s ease;
    transition: all 1s ease;
  }

  .logo:hover {
    -webkit-filter: brightness(130%);
    filter: brightness(130%);
    @apply scale-110;
  }

  @keyframes animatedgradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  .navBarLink:not(.activeLink) {
    @apply hover:text-pink-500 hover:scale-110;
  }
</style>

<nav class="bg-transparent py-2">
  <div id='navBar' class="mx-auto" style="max-width: 100rem;">
    <div class="flex justify-between transition duration-500">
      <!-- Logo -->
      <div>
        <div class="py-4 px-2 text-white font-semibold text-2xl flex justify-center items-center">
          <!-- Website Logo -->
          <img src='logo.png' width='80px' />
          <a href="{($location =='/') ? '#' : '#/Index'}" class='no-underline logo'><img src='solainutext.png' width='300px' /></a>
        </div>
      </div>
      <div class="clicked flexed">
      </div>
      <!-- Main Menu -->
      <div class="text-lg hidden md:flex justify-center items-center space-x-3 flexed">
        {#if featureFlag}
          <Link href="#/Farm"         className="navBarLink {($location == '/Farm')        ? 'activeLink bg-pink-500' : ''}">Farm</Link>
        {/if}
  
        <Link href="#/Info"         className="navBarLink {($location == '/Info')        ? 'activeLink bg-pink-500' : ''}">Info</Link>
        <Link href="#/Airdrop"      className="navBarLink {($location == '/Airdrop')        ? 'activeLink bg-pink-500' : ''}">Airdrop</Link>
        {#if featureFlag}
          <Link href="#/Buy"          className="navBarLink {($location == '/Buy')         ? 'activeLink bg-pink-500' : ''}">Buy</Link>
        {/if}

        <a href="https://neonpass.live/" class="navBarLink">Bridge</a>
      </div>
      <Wallet />
      <!-- Metamask Navbar items -->
      <div class="flex items-center space-x-2 justify-center">
        <Provider />
      </div>
    </div>
  </div>
</nav>

<script>
  import Wallet from './wallet.svelte';
  import Provider from './provider.svelte';
  import Link from './link.svelte';
  import {location} from 'svelte-spa-router'

  $: featureFlag = false;
</script>
